import { z } from "zod"
import { addressSchema, countrySchema, customerSchema } from "@nano-portal/customers"
import { withOptionalEmptyStringAsUndefined } from "@nano-portal/shared"
import { useSafeLocalStorage } from "../../../../../utils/localStorage"
import { dateSchema } from "../utils"

export const householdContactFormSchema = z.object({
  firstName: customerSchema.shape.firstName,
  lastName: customerSchema.shape.lastName,
  email: customerSchema.shape.email,
  phone: customerSchema.shape.phone,

  birthDate: dateSchema.shape.date,
  birthMonth: dateSchema.shape.month,
  birthYear: dateSchema.shape.year,

  addressStreet: addressSchema.shape.street,
  addressDescriptiveNumber: addressSchema.shape.descriptiveNumber,
  addressOrientationNumber: withOptionalEmptyStringAsUndefined(addressSchema.shape.orientationNumber),
  addressCity: addressSchema.shape.city,
  addressPostalCode: addressSchema.shape.postalCode,
  addressCountryCode: countrySchema,

  contactAddress: z
    .object({
      street: addressSchema.shape.street,
      descriptiveNumber: addressSchema.shape.descriptiveNumber,
      orientationNumber: withOptionalEmptyStringAsUndefined(addressSchema.shape.orientationNumber),
      city: addressSchema.shape.city,
      postalCode: addressSchema.shape.postalCode,
      countryCode: countrySchema,
    })
    .nullish(),

  deliveryPointAddress: z
    .object({
      street: addressSchema.shape.street,
      descriptiveNumber: addressSchema.shape.descriptiveNumber,
      orientationNumber: withOptionalEmptyStringAsUndefined(addressSchema.shape.orientationNumber),
      city: addressSchema.shape.city,
      postalCode: addressSchema.shape.postalCode,
    })
    .nullish(),

  gdprConsent: z.boolean().refine((value) => value, { message: "Nejdříve, prosím, odsouhlaste podmínky." }),
})

export type HouseholdContactFormVales = z.infer<typeof householdContactFormSchema>

export function useStoredHouseholdContactFormValues() {
  return useSafeLocalStorage({
    key: "acquisition-form-household-contact",
    schema: householdContactFormSchema,
  })
}
